'use client';

import { c as _c } from "react/compiler-runtime";
import { type GetCreatedMarketsAndProposalsRow, useGetCreatedMarketsAndProposalsField, useGetProposalsField, useMarketConfig } from '@morfi/backend-sdk-v2/client';
import { adaptProposalRow } from '@/components/launchpad/adapt-proposal-row';
import { ProposalFeedRow } from '@/components/launchpad/proposal-feed-row';
import { ProposalFeedRowSkeleton } from '@/components/launchpad/proposal-feed-row-skeleton';
export function CreatedProposalRow(t0) {
  const $ = _c(22);
  const {
    pubkey,
    snapshot
  } = t0;
  const funded = useGetProposalsField(pubkey, "totalFunded");
  const staked = useGetProposalsField(pubkey, "totalStaked");
  const backers = useGetProposalsField(pubkey, "numBackers");
  const top = useGetProposalsField(pubkey, "topBackers");
  const upvotes = useGetProposalsField(pubkey, "upvotes");
  const downvotes = useGetProposalsField(pubkey, "downvotes");
  const netVotes = useGetProposalsField(pubkey, "netVotes");
  const myVote = useGetCreatedMarketsAndProposalsField(pubkey, "myVote");
  const score = useGetProposalsField(pubkey, "proposalScore");
  const config = useMarketConfig(snapshot?.proposal?.marketConfig);
  if (snapshot?.proposal == null || config === undefined) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <ProposalFeedRowSkeleton />;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    return t1;
  }
  const t1 = funded ?? snapshot.proposal.totalFunded;
  const t2 = staked ?? snapshot.proposal.totalStaked;
  const t3 = backers ?? snapshot.proposal.numBackers;
  const t4 = upvotes ?? snapshot.proposal.upvotes;
  const t5 = downvotes ?? snapshot.proposal.downvotes;
  const t6 = netVotes ?? snapshot.proposal.netVotes;
  const t7 = myVote === undefined ? snapshot.myVote : myVote;
  let T0;
  let t8;
  if ($[1] !== config || $[2] !== snapshot.proposal || $[3] !== t1 || $[4] !== t2 || $[5] !== t3 || $[6] !== t4 || $[7] !== t5 || $[8] !== t6 || $[9] !== t7) {
    const row = {
      ...snapshot.proposal,
      totalFunded: t1,
      totalStaked: t2,
      numBackers: t3,
      upvotes: t4,
      downvotes: t5,
      netVotes: t6,
      myVote: t7
    };
    T0 = ProposalFeedRow;
    t8 = adaptProposalRow(row, config);
    $[1] = config;
    $[2] = snapshot.proposal;
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
    $[6] = t4;
    $[7] = t5;
    $[8] = t6;
    $[9] = t7;
    $[10] = T0;
    $[11] = t8;
  } else {
    T0 = $[10];
    t8 = $[11];
  }
  const t9 = score ?? snapshot.proposal.proposalScore ?? "medium";
  let t10;
  if ($[12] !== snapshot.proposal || $[13] !== top) {
    t10 = top ?? snapshot.proposal.topBackers ?? [];
    $[12] = snapshot.proposal;
    $[13] = top;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] !== t10) {
    t11 = t10.map(_temp);
    $[15] = t10;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  let t12;
  if ($[17] !== T0 || $[18] !== t11 || $[19] !== t8 || $[20] !== t9) {
    t12 = <T0 proposal={t8} proposalScore={t9} topBackers={t11} />;
    $[17] = T0;
    $[18] = t11;
    $[19] = t8;
    $[20] = t9;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  return t12;
}
function _temp(t0) {
  const {
    backer
  } = t0;
  return {
    walletAddress: backer.walletAddress,
    displayName: backer.displayName ?? null,
    avatarUrl: backer.avatarUrl ?? null,
    avatarNsfw: backer.avatarNsfw === true
  };
}